module.exports = __webpack_public_path__ + "img/certificate_icon.71e9f9b4.svg";